import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { statsAPI } from "../axios/stats-axios";
import { DEFAULT_MATCH_TYPE } from "../utils/searchRequest";

const DONATION_URL =
  "https://www.givecampus.com/campaigns/47387/donations/new?a=8830926&designation=089252";
const BROWSE_DONATION_CLICK_COUNT_KEY = "browseDonationClickCount";
const BROWSE_DONATION_PROMPT_SHOWN_KEY = "browseDonationPromptShown";
const DONATION_PROMPT_CLICK_COUNT = 5;

const useHome = () => {
  const [loading, setLoading] = useState(false);
  const [collections, setCollections] = useState(0);
  const [pages, setPages] = useState(0);
  const [documents, setDocuments] = useState(0);
  const [focus, setFocus] = useState(false);
  const [donationPrompt, setDonationPrompt] = useState({
    show: false,
    nextPath: "",
    nextState: null,
  });
  const navigate = useNavigate();

  const shouldShowDonationPrompt = (nextPath, nextState) => {
    const hasShownDonationPrompt =
      localStorage.getItem(BROWSE_DONATION_PROMPT_SHOWN_KEY) === "true";

    if (hasShownDonationPrompt) {
      return false;
    }

    const currentCount =
      Number(localStorage.getItem(BROWSE_DONATION_CLICK_COUNT_KEY)) || 0;
    const nextCount = currentCount + 1;

    localStorage.setItem(
      BROWSE_DONATION_CLICK_COUNT_KEY,
      JSON.stringify(nextCount)
    );

    if (nextCount === DONATION_PROMPT_CLICK_COUNT) {
      localStorage.setItem(BROWSE_DONATION_PROMPT_SHOWN_KEY, "true");
      setDonationPrompt({
        show: true,
        nextPath,
        nextState,
      });
      return true;
    }

    return false;
  };

  const navigateToBrowse = (nextPath, nextState) => {
    setLoading(true);
    navigate(nextPath, { state: nextState });
    setLoading(false);
  };

  const handleBrowsePeriodicalClick = () => {
    const nextPath = "/browse-periodicals";
    const nextState = { coll_type: "periodical", browseResults: [] };

    if (!shouldShowDonationPrompt(nextPath, nextState)) {
      navigateToBrowse(nextPath, nextState);
    }
  };

  const handleBrowseBooksClick = () => {
    const nextPath = "/browse-books";
    const nextState = { coll_type: "book", browseResults: [] };

    if (!shouldShowDonationPrompt(nextPath, nextState)) {
      navigateToBrowse(nextPath, nextState);
    }
  };

  const handleDonationPromptClose = () => {
    setDonationPrompt({
      show: false,
      nextPath: "",
      nextState: null,
    });
  };

  const handleDonationPromptContinue = () => {
    const { nextPath, nextState } = donationPrompt;
    handleDonationPromptClose();

    if (nextPath) {
      navigateToBrowse(nextPath, nextState);
    }
  };

  useEffect(() => {
    localStorage.setItem("searchTerm", JSON.stringify(""));
    localStorage.setItem("searchResults", JSON.stringify([]));
    localStorage.setItem("matchType", JSON.stringify(DEFAULT_MATCH_TYPE));
    localStorage.setItem("searchItemsSet", JSON.stringify(false));
    localStorage.setItem("analytics", JSON.stringify({}));
    localStorage.setItem("filters", null);
  }, []);

  useEffect(() => {
    getStats();
  }, []);

  const getStats = async () => {
    try {
      const response = await statsAPI.get("");
      const { collections, pages, documents } = response.data;
      setCollections(collections);
      setPages(pages);
      setDocuments(documents);
    } catch (error) {
      console.log(error);
    }
  };

  return {
    loading,
    setLoading,
    collections,
    pages,
    documents,
    focus,
    setFocus,
    handleBrowseBooksClick,
    handleBrowsePeriodicalClick,
    donationPrompt,
    donationUrl: DONATION_URL,
    handleDonationPromptClose,
    handleDonationPromptContinue,
    getStats,
    navigate,
  };
};

export default useHome;
